import React, { Component } from "react";
import "./CarForm.css";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

import Button from "@material-ui/core/Button";
import { fade, makeStyles, withStyles } from "@material-ui/core/styles";
import InputBase from "@material-ui/core/InputBase";

import Paper from "@material-ui/core/Paper";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import { createMuiTheme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import CarFormDetail from "../CarFormDetail/CarFormDetail";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";

const ColorButton = withStyles(theme => ({
  root: {
    fontFamily: "ToyotaRegular",
    fontWeight: "bold",
    borderColor: red[500],
    backgroundColor: red[500],
    color: theme.palette.getContrastText(red[50]),
    color: red[50],
    borderRadius: 20,
    "&:hover": {
      backgroundColor: red[100],
      color: theme.palette.getContrastText(red[500]),
      color: red[700]
    }
  }
}))(Button);

const imgStyle = {
  width: "50%",
  height: "50%",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto"
};

const BootstrapInput = withStyles(theme => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3)
    }
  },
  input: {
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid rgba(179, 179, 179, 0.2)",
    color: "rgba(120, 120, 120, 1)",
    fontSize: "0.7rem",
    width: "100%",
    padding: "10px 12px",
    borderRadius: "0px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: "ToyotaRegular",
    "&:focus": {
      boxShadow: `${fade(theme.palette.primary.main, 0.1)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main
    }
  }
}))(InputBase);

class CarForm extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = event => {};

  componentDidMount() {}

  useStyles = () =>
    makeStyles(theme => ({
      button: {
        margin: theme.spacing(1),
        primary: red
      },
      input: {
        display: "none"
      }
    }));

  startHandler = () => {
    this.props.history.replace("/game");
  };

  leaderboardHandler = () => {
    this.props.history.replace("/leaderboard");
  };

  render() {
    const classes = this.useStyles();

    return (
      <div>
        <Header />
        <div className="GridCarForm">
          <Grid item xs={12} sm={12} spacing={5}>
            <br />
            <Link className="VolverLink">{"< Volver"}</Link>
            <div className="CarFormTitle">
              ¡Sólo falta un paso! Hacé la reserva.
              <br />
              <div className="CarFormText"> El monto mínimo es de $5.000.</div>
            </div>
          </Grid>
          <Grid container spacing={5} xs={12} sm={12}>
            <Grid container spacing={3} xs={12} sm={7}>
              <Grid item xs={10} sm={11}>
                <div className="CarFormBox">
                  <div className="CarFormTitle2">¿Con cuanto reservás?</div>
                  <br />
                  <FormControl className="InputFormControl">
                    <InputLabel shrink htmlFor="monto-input" className="Label">
                      Monto de la reserva
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Recordá que el minimo es $5000."
                      id="monto-input"
                    />
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={10} sm={11}>
                <div className="CarFormBox">
                  <div className="CarFormTitle2">
                    ¿Con qué pagás la reserva?
                  </div>
                  <br />
                  <FormControlLabel
                    value="nosotros"
                    control={<Radio />}
                    label="Tarjeta de crédito"
                    className="RadioLabel"
                  />
                  <div className="CarFormLine2"></div>
                  <FormControlLabel
                    value="nosotros"
                    control={<Radio />}
                    label="Tarjeta de débito"
                    className="RadioLabel"
                  />
                </div>
              </Grid>
              <Grid item xs={10} sm={11}>
                <div className="CarFormBox">
                  <div className="CarFormTitle2">Datos de la Tarjeta</div>
                  <br />
                  <FormControl className="InputFormControl">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Banco
                    </InputLabel>
                    <Select
                      onChange={this.handleChange}
                      inputProps={{
                        name: "bank",
                        id: "bank"
                      }}
                      displayEmpty
                      name="age"
                      className="SelectInput"
                    >
                      <MenuItem value="">
                        <em>Seleccioná el banco al que pertenece tu tarjeta</em>
                      </MenuItem>
                      <MenuItem value={10}>Nación</MenuItem>
                      <MenuItem value={20}>Hipotecario</MenuItem>
                      <MenuItem value={30}>Santander</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl className="InputFormControlSub">
                    <InputLabel shrink htmlFor="card" className="Label">
                      Tarjeta
                    </InputLabel>
                    <Select
                      onChange={this.handleChange}
                      inputProps={{
                        name: "card",
                        id: "card"
                      }}
                      name="age"
                      className="SelectInput"
                    >
                      <MenuItem value="">
                        <em>Seleccioná tu tarjeta</em>
                      </MenuItem>
                      <MenuItem value={10}>Visa</MenuItem>
                      <MenuItem value={20}>Mastercard</MenuItem>
                      <MenuItem value={30}>AMEX</MenuItem>
                    </Select>
                  </FormControl>

                  <FormControl className="InputFormControlSub">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Número de la Tarjeta
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Ingresá el número de tu tarjeta"
                      id="monto-input"
                    />
                  </FormControl>
                  <FormControl className="InputFormControlSub1">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Vencimiento
                    </InputLabel>
                    <BootstrapInput defaultValue="MM/AA" id="monto-input" />
                  </FormControl>
                  <FormControl className="InputFormControlSub2">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Cód. Seguridad
                    </InputLabel>
                    <BootstrapInput defaultValue="xxx" id="monto-input" />
                  </FormControl>
                  <FormControl className="InputFormControlSub">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Titular de la tarjeta
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Como figura en la tarjeta."
                      id="monto-input"
                    />
                  </FormControl>
                  <FormControl className="InputFormControlSub">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Documento del titular de la tarjeta
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Ej.:30891632"
                      id="monto-input"
                    />
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={10} sm={11}>
                <div className="CarFormBox">
                  <div className="CarFormTitle2">
                    Datos para envio de reserva:
                  </div>
                  <br />
                  <FormControl className="InputFormControl">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      E-mail
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Ingresá un mail de contacto"
                      id="monto-input"
                    />
                  </FormControl>
                  <FormControl className="InputFormControlSub">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Confirma tu e-mail
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Re-ingresá un mail de contacto"
                      id="monto-input"
                    />
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={10} sm={11}>
                <div className="CarFormBox ">
                  <div className="CarFormTitle2">Telefono de contacto:</div>
                  <FormControl className="InputFormControlSub1">
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Area
                    </InputLabel>
                    <BootstrapInput defaultValue="11" id="monto-input" />
                  </FormControl>
                  <FormControl
                    className="InputFormControlSub2"
                    style={{ width: "40%" }}
                  >
                    <InputLabel shrink htmlFor="bank" className="Label">
                      Número
                    </InputLabel>
                    <BootstrapInput
                      defaultValue="Ingresá un número"
                      id="monto-input"
                    />
                  </FormControl>
                </div>
              </Grid>
              <Grid item xs={10} sm={11}>
                <div className="CheckDiv">
                  <Checkbox
                    checked={false}
                    value="checkedA"
                    inputProps={{
                      "aria-label": "primary checkbox"
                    }}
                  />
                  <div className="TextCheck">
                    Leí y acepto las condiciones de compra y políticas de
                    privacidad
                  </div>
                </div>
              </Grid>
              <Grid item xs={10} sm={11}>
                <div className="ReservarButtonForm">
                  <Link to="/carformconfirm">
                    <img src="/img/reservar.png" className="ReservarImg" />
                  </Link>
                </div>
              </Grid>
            </Grid>
            <CarFormDetail />
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CarForm;
